import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import AccessController from "../../access-controler/AccessController";
import { icon } from "../../../../../common/components";
import ViewTable from "./ViewTable";
import { useApi } from "../../../../../common/hooks";
import { LicenceManagementService } from "../../../../../api";
import { setUpdateLicenceManagement } from "../../../../../common/slice";
import { translate } from "../../../../../common/providers";

export default function ViewContent({ page, hasEngagementAccess, setHasEngagementAccess }) {
	const licenceManagementStore = useSelector(({ context }) => context.licenceManagement);

	const dispatch = useDispatch();
	const { call: getStatusCertificatByUser } = useApi(LicenceManagementService.getStatusCertificatByUser);
	const { call: lockAccessUserByCompany } = useApi(LicenceManagementService.lockAccessUserByCompany);
	const { call: unlockAccessUserByCompany } = useApi(LicenceManagementService.unlockAccessUserByCompany);
	const { call: addAccessUserCertificate } = useApi(LicenceManagementService.addAccessUserCertificate);

	const handelGetStatusCertificates = () => {
		getStatusCertificatByUser({ userId: licenceManagementStore?.selectedUser?.id })
			.then((data) => {
				dispatch(setUpdateLicenceManagement({ certificatesStatus: data }));
			})
			.catch(console.error);
	};

	const handelUnlockAccessUserByCompany = () => {
		unlockAccessUserByCompany({
			userId: licenceManagementStore?.selectedUser?.id,
			companyId: licenceManagementStore.certificatesStatus.companyId,
		})
			.then(() => {
				handelGetStatusCertificates();
			})
			.catch(console.error);
	};

	const handeLockAccessUserByCompany = () => {
		lockAccessUserByCompany({
			userId: licenceManagementStore?.selectedUser?.id,
			companyId: licenceManagementStore.certificatesStatus.companyId,
		})
			.then(() => {
				handelGetStatusCertificates();
			})
			.catch(console.error);
	};

	const handelAddAccessUserCertificate = () => {
		addAccessUserCertificate({
			payload: { value: licenceManagementStore.selectedUser.profil },
			userId: licenceManagementStore?.selectedUser?.id,
		})
			.then(() => {
				handelGetStatusCertificates();
			})
			.catch(console.error);
	};

	useEffect(() => {
		handelGetStatusCertificates();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [licenceManagementStore.selectedUser]);

	const { call: updateUserCommitmentAccess } = useApi(LicenceManagementService.updateUserCommitmentAccess);

	const handleToggleEngagementAccess = (add) => {
		updateUserCommitmentAccess({ userId: licenceManagementStore?.selectedUser?.id, add })
			.then(() => {
				setHasEngagementAccess(add);
			})
			.catch(console.error);
	};

	const renderSuiviEngagementsContent = () => {
		if (hasEngagementAccess) {
			return (
				<Grid p={1}>
					<AccessController
						btnName={translate("common:licence-management.user.access-control.remove-access")}
						color="var(--blue-50)"
						description={translate(
							"common:licence-management.user.access-control.commitment-tracking-active-description"
						)}
						icon={icon.faCheck}
						iconClassName="iconActive"
						title={translate("common:licence-management.user.access-control")}
						onClick={() => handleToggleEngagementAccess(false)}
					/>
				</Grid>
			);
		}
		return (
			<Grid p={1}>
				<AccessController
					btnName={translate("common:licence-management.user.access-control.accord-access")}
					color="var(--color-yellow-20)"
					description={translate(
						"common:licence-management.user.access-control.commitment-tracking-inactive-description"
					)}
					icon={icon.faExclamationTriangle}
					iconClassName="iconInActive"
					title={translate("common:licence-management.user.access-control")}
					onClick={() => handleToggleEngagementAccess(true)}
				/>
			</Grid>
		);
	};

	return (
		<Grid>
			{(page.name === "Contrats" && <ViewTable />) ||
				(page.name === "SuiviEngagements" && renderSuiviEngagementsContent()) || (
					<Grid>
						{/* eslint-disable-next-line no-nested-ternary */}
						{(licenceManagementStore?.certificatesStatus?.hasCertificat &&
							licenceManagementStore?.certificatesStatus?.userStatus === "ACTIVE" && (
								<Grid p={1}>
									<AccessController
										btnName={translate(
											"common:licence-management.user.access-control.remove-access"
										)}
										color="var(--blue-50)"
										description={translate(
											"common:licence-management.user.access-control.active-description"
										)}
										icon={icon.faCheck}
										iconClassName="iconActive"
										title={translate("common:licence-management.user.access-control")}
										onClick={handeLockAccessUserByCompany}
									/>
								</Grid>
							)) ||
							(licenceManagementStore?.certificatesStatus?.hasCertificat &&
								licenceManagementStore?.certificatesStatus?.userStatus === "BLOCKED" && (
									<Grid p={1}>
										<AccessController
											btnName={translate(
												"common:licence-management.user.access-control.accord-access"
											)}
											color="var(--color-yellow-20)"
											description={translate(
												"common:licence-management.user.access-control.blocked-description"
											)}
											icon={icon.faExclamationTriangle}
											iconClassName="iconInActive"
											title={translate("common:licence-management.user.access-control")}
											onClick={handelUnlockAccessUserByCompany}
										/>
									</Grid>
								)) || (
								<Grid p={1}>
									<AccessController
										btnName={translate(
											"common:licence-management.user.access-control.accord-access"
										)}
										color="var(--color-yellow-20)"
										description={translate(
											"common:licence-management.user.access-control.inactive-description"
										)}
										icon={icon.faExclamationTriangle}
										iconClassName="iconInActive"
										title={translate("common:licence-management.user.access-control")}
										onClick={handelAddAccessUserCertificate}
									/>
								</Grid>
							)}
					</Grid>
				)}
		</Grid>
	);
}
